const STORAGE_FILE_CATEGORIES = {
  MESSAGE_TEMPLATE_MEDIA: "message_template_media",
};

export default STORAGE_FILE_CATEGORIES;
